<template>
	<div id="sltemplate">
		<div class="maskAux" v-show="loadstatus.auxliaryModal" @click="tips"></div>
		<el-form ref="form" :model="slform" label-width="40px" inline>
			<div v-show="numberAccount">
				<el-form-item label="数量:">
					<el-input
						v-model="slform.num" ref="input1"
						@blur="selectChanges" @keyup.enter.native = "enterInputBlur('num','input2')"
						@keydown.tab.native.prevent = "tabChanges($event,'num')"
						@keyup.native = "filterNum('num')"
						size="mini" style="width:45px"></el-input>
				</el-form-item>
				<el-form-item label="单价:">
					<el-input
						v-model="slform.dj"  ref="input2"
						@blur="selectChanges"
						@keyup.enter.native = "enterInputBlur('dj','input3')"
						@keyup.native = "filterNum('dj')"
						@keydown.tab.native.prevent = "tabChanges($event,'dj')"
						size="mini" style="width:45px"></el-input>
				</el-form-item>
        <el-form-item label="单位:">
          <span style="font-size: 12px;">{{ slform.unit }}</span>
				</el-form-item>
				<div class="middHandle">
					<span :title="num">数量余额:{{num}}</span>
					<span :title="pirce" class="ml15">平均单价:{{pirce}}</span>
          <!-- <span v-if="slObjUnit.length>2" :title="slObj.subjectVo.unit">单位:{{slObjUnit.substr(0,2) +'…'}}</span>
				  <span v-else :title="slObjUnit">单位:{{slObjUnit}}</span> -->
				</div>
			</div>
			<div v-show="foreignCurrency">
				<el-form-item label="">
					<el-select
					size="mini" style="width:70px"
					v-model="slform.bz"  ref="input3"
					@change="selectChanges1"
					@keyup.enter.native = "enterInputBlur('bz','input4')"
					@keydown.tab.native.prevent = "tabChanges($event,'bz')"
					>
						<el-option v-for="(item,index) in currencyList" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="原币:">
					<el-input
						@blur="selectChanges1('')" @keyup.enter.native = "enterInputBlur('yb','input5')"
						size="mini" v-model="slform.yb" ref="input4" :maxlength="9"
						@keydown.tab.native.prevent = "tabChanges($event,'yb')"
						@keyup.native = "filterNum('yb')"
						style="width:40px" class="mini"></el-input>
				</el-form-item>
				<el-form-item label="汇率:">
					<el-input
						@blur="selectChanges1('')" @keyup.enter.native = "enterInputBlur('hl','done')"
						size="mini" v-model="slform.hl"  ref="input5"
						@keyup.native = "filterNum('hl')"
						@keydown.tab.native.prevent = "tabChanges($event,'hl')"
						style="width:40px" class="mini"></el-input>
				</el-form-item>
			</div>
		</el-form>
	</div>
</template>

<script>
	import {mapState,mapMutations} from 'vuex';
  import { debounce } from '@/assets/utils'
export default {
	props:['slObj','inputFocus'],
	data(){
		return {
			loading:false,
			title:'数量核算',
			slform:{
				num:0,
				dj:0,
        unit:'', // 数量核算单位
				bz:'',
				yb:0,
				hl:0,
				money:0,
			},
			numberAccount:false,
			foreignCurrency:false,
			currencyList:[],

			num:'',
			nums:'',
			pirce:'',
      isCanReq: true
		}
	},
	created(){
		this.init();
	},
	methods:{
		init(){

		},
		getForeignBySubjectId(row){
      if(!this.isCanReq) {
        return
      }
      this.isCanReq = false
      setTimeout(() => {
        this.isCanReq = true
      },1000)
			const _=this;
			let id = row.subjectVo.id
			var bols = this.$store.state.loadstatus.voucherEdit;

			if(id){// 只要存在id就需要查询接口
				_.loading = true;
				_.$http.post('foreignCurrency/getForeignBySubjectId',{
					subjectId:id,
					yearPeriods: _.$getSessionStorage('voucher')?_.$getSessionStorage('voucher').yearPeriods:''
				}).then((res)=>{
					_.loading = false;
					if(res && res.data.code == '1'){
						_.currencyList = res.data.data.foreignCurrencys;
						_.num = res.data.data.initialAmount;
						_.nums = res.data.data.remainingSum;
						_.numberChange('none');
						if(_.num == null || isNaN(_.num) || _.num == 0){
							_.pirce = 0;
						}else{
							_.pirce = (res.data.data.remainingSum/res.data.data.initialAmount).toFixed(2);
						};
						//如果没有选择的币种 则设置默认币种 本位币
						if(row.fkForeignCurrencyId && row.fkForeignCurrencyId != '' && row.fkForeignCurrencyId != null){
							_.$nextTick(function(){
								_.$set(_.slform,'bz',row.fkForeignCurrencyId);
								_.slform.hl = row.exchangerate;
							});
						}else{
              for(let i=0;i<_.currencyList.length;i++){
                  if(_.currencyList[i].standard){
                    _.$nextTick(function(){
                      _.$set(_.slform,'bz',_.currencyList[i].id);
                      _.slform.hl = _.currencyList[i].exchangerate;
                    });
                  }
                };
							// if(_.currencyList.length == 1){
							// 	_.$nextTick(function(){
							// 		_.$set(_.slform,'bz',_.currencyList[0].id);
							// 		_.slform.hl = _.currencyList[0].exchangerate;
							// 	});
							// }

						};
					}
				}).catch((e)=>{
					_.loading = false;
				});
			}
		},
		selectChanges(val){  /// 计算数量和单价 ======================
			const _=this;
			//金额计算问题
			_.$store.commit('UPDATEAMONEYEACH',true);
			_.$store.commit('UPDATEAMONEYEACH1',false);
			//计算金额
			if(_.slform.num != 0 && _.slform.num != '' && _.slform.dj != 0 && _.slform.dj != ''){
				_.slform.money = parseFloat((_.slform.num  * _.slform.dj).toFixed(2));
			}else{
				_.slform.money = 0;
			};
			_.numberChange();
		},
		selectChanges1(val){/// 计算原币和汇率 ======================
			const _=this;
			//金额计算问题
			_.$store.commit('UPDATEAMONEYEACH',false);
			_.$store.commit('UPDATEAMONEYEACH1',true);
			if(val && val != null && val != ''){
				this.$store.commit('UPDATAVOUCHEREDIT',true);
				let items = _.currencyList.find(item=>{
					if(item.id == val){
						return item;
					}
				});
				_.slform.hl = items.exchangerate;
			}
			//计算金额  原币-汇率
			if(_.slform.yb != 0 && _.slform.yb != '' && _.slform.hl != 0 && _.slform.hl != ''){
				_.slform.money = parseFloat((_.slform.yb  * _.slform.hl).toFixed(2));
			}else{
				_.slform.money = 0;
			};
			_.numberChange("",true);
		},
		numberChange(key,isEdit){
			const _=this;
			let datas = JSON.parse(JSON.stringify(_.slform));
			let data = {
				debitAmount:datas.num,		//数量 --借方
				creditorAmount:datas.num,	//数量 --贷方
				unit:datas.dj,				//单价
				nums:_.nums,						//余额 -- 科目
				fkForeignCurrencyId:datas.bz?datas.bz:this.slObj.fkForeignCurrencyId,  //外币id
				debitCoin:datas.yb,			//借方 原币
				creditorCoin:datas.yb,		//贷方 原币
				exchangerate:datas.hl?datas.hl:this.slObj.exchangerate,
				money:datas.money,

				none:key ? key : '',
			};
			this.$emit('on-push-slForeign',JSON.parse(JSON.stringify(data)));
		},
		changesMoneys(row){
			const _=this;
			let d = JSON.parse(JSON.stringify(row));
			let m = _.$store.state.loadstatus.moneyOtherEach;
			let m1 = _.$store.state.loadstatus.moneyOtherEach1;
			var numMoney  = 0;
			if(d.debitMoney != 0){
				numMoney = Math.abs(d.debitMoney);
			}else if(d.creditorMoney != 0){
				numMoney = Math.abs(d.creditorMoney);
			}else{
				numMoney = 0;
			};
			if(d.subjectVo.numberAccounting && !m){//当存在数量核算
				if(_.slform.num != 0){
					if((numMoney%_.slform.num) == 0){
						_.slform.dj = numMoney/_.slform.num;
					}else{
						_.slform.dj = this.spliceNum((numMoney/_.slform.num),9);
					}
					_.numberChange();
				};
			};
			if(d.subjectVo.foreignCurrency && !m1){//当存在外币核算
				if(_.slform.hl != 0){
					if((numMoney%_.slform.hl) == 0){
						_.slform.yb = numMoney/_.slform.hl;
					}else{
						_.slform.yb = this.spliceNum((numMoney/_.slform.hl),2);
					}
					_.numberChange();
				};
			};
		},//设置值
		setDatas(row,ca){
			const _=this;
			// _.num = row.debitAmount;
			// _.pirce = row.debitAmount;
      this.slform.unit = row.subjectVo.unit || "";
      this.slObj.bz = row.fkForeignCurrencyId;
      this.slObj.hl = row.exchangerate;
			_.numberAccount = row.subjectVo.numberAccounting;
			_.foreignCurrency = row.subjectVo.foreignCurrency;
			if(row.creditorAmount != null && row.debitAmount != null){
				_.slform.num = row.debitAmount == 0 ?  row.creditorAmount : row.debitAmount;
			}else{
				// _.slform.num = 0;
			};
			if(row.creditorCoin >= 0 &&  row.debitCoin >=0 && row.creditorCoin != null && row.debitCoin != null){
				_.slform.yb = row.debitCoin? row.debitCoin:row.creditorCoin;
			}else{
				_.slform.yb = 0;
			};
			_.slform.dj = row.unit;
			_.slform.money = row.debitMoney == 0 ? row.creditorMoney : row.debitMoney;

			//获取到值进行运算
			_.changesMoneys(row);
		},
		enterInputFocus(Val){
			const _=this;
			if(Val.slInputFocus){
				if(_.numberAccount && _.foreignCurrency){
					_.$nextTick(()=>{
						if(Val.slEndInputFocus){
							_.$refs.input5.focus();
							_.$refs.input5.select();
						}else{
							_.$refs.input1.focus();
							_.$refs.input1.select();
						}
					});
				}else if(_.numberAccount && !_.foreignCurrency){
					_.$nextTick(()=>{
						if(Val.slEndInputFocus){
							_.$refs.input2.focus();
							_.$refs.input2.select();
						}else{
							_.$refs.input1.focus();
							_.$refs.input1.select();
						}
					});
				}else if(!_.numberAccount && _.foreignCurrency){
					_.$nextTick(()=>{
						if(Val.slEndInputFocus){
							_.$refs.input5.focus();
							_.$refs.input5.select();
						}else{
							_.$refs.input3.focus();
						}
					});
				};
			}
		},//enter 事件
		enterInputBlur(val,ref){
			const _=this;
			if(val != 'bz'){
				if(ref == 'input3' && !_.foreignCurrency){
					_.$emit('on-enter-keyDown',true);
				}else if(ref == 'done'){
					_.$emit('on-enter-keyDown',true);
				}else if(_.slform[val] != 0 && _.slform[val] != '' && ref != 'done'){
					_.$nextTick(()=>{
						_.$refs[ref].focus();
						_.$refs[ref].select();
					});
				};
			}else{
				if(_.slform[val] != '' && _.slform[val] != null){
					_.$refs['input3'].blur();
					_.$nextTick(()=>{
						_.$refs[ref].select();
					});
				}else{
					_.$refs['input3'].focus();
				}
			};

		},//tab事件控制
		tabChanges(val,key){
			const _=this;
			if(val.shiftKey){
				if(key == 'num'){
					_.$refs['input1'].blur();
					_.$emit('on-tab-focusChange',false);
				};
				if(key == 'bz' && _.foreignCurrency && !_.numberAccount){
					_.$emit('on-tab-focusChange',false);
				};
				if(key == 'dj'){
					_.$refs['input2'].blur();
					_.$refs['input1'].focus();
					_.$refs['input1'].select();
				}else if(key == 'bz'){
					_.$refs['input3'].blur();
					_.$refs['input2'].focus();
					_.$refs['input2'].select();
				}else if(key == 'yb'){
					_.$refs['input4'].blur();
					_.$refs['input3'].focus();
				}else if(key == 'hl'){
					_.$refs['input5'].blur();
					_.$refs['input4'].focus();
					_.$refs['input4'].select();
				};
			}else{
				if(key == 'dj' && _.numberAccount && !_.foreignCurrency){
					_.$emit('on-tab-focusChange',true);
				};
				if(key == 'hl'){
					_.$refs['input5'].blur();
					_.$emit('on-tab-focusChange',true);
				};
				if(key == 'num'){
					_.$refs['input1'].blur();
					_.$refs['input2'].focus();
					_.$refs['input2'].select();
				}else if(key == 'dj'){
					_.$refs['input2'].blur();
					_.$refs['input3'].focus();
				}else if(key == 'bz'){
					_.$refs['input3'].blur();
					_.$refs['input4'].focus();
					_.$refs['input4'].select();
				}else if(key == 'yb'){
					_.$refs['input4'].blur();
					_.$refs['input5'].focus();
					_.$refs['input5'].select();
				};
			}
		},
		filterNum(key){//筛选金额
			const _=this;
			this.$store.commit('UPDATAVOUCHER',true);
			this.$store.commit('UPDATAVOUCHER_SUPER',false);
			if(_.slform[key] != 0){
				_.slform[key] = this.spliceNum(_.slform[key],999,key);
			}
		},
		spliceNum(num,s,key){
			const _=this;
			s = s || 1;
			if(num != 0){
				let reg = key == "num"?/[^0-9.-]/g:/[^0-9.]/g;
				num = num.toString().replace(reg,'');
				if(num.indexOf('.') != -1){
					let point = num.indexOf('.')+(s+1);
					let p = num.split('.')[1];
					if(p.length >= s){
						num = num.substring(0,point);
					}
				}
			}
			return num;
		},
		tips(){
			this.$message.error('请选择辅助核算！');
		}
	},
	mounted(){
	},
	computed:{
		...mapState([
				'loadstatus'
			]),
    slObjUnit(){
      return this.slObj.subjectVo.unit || '-';
    }
	},
	activated(){
		this.getForeignBySubjectId(this.slObj);
	},
	watch: {
		slObj:{
			handler(Val,Old){
        console.log("当前收到的变化值=========》",Val);

				const _=this;
				var bols = this.$store.state.loadstatus.voucherEdit;
        _.numberAccount = Val.subjectVo.numberAccounting;
        _.foreignCurrency = Val.subjectVo.foreignCurrency;
				//当为修改凭证是 只有辅助核算和外币核算才计算 其他只有科目变化是才调用
				if(Val.subjectVo.numberAccounting || Val.subjectVo.foreignCurrency){
					_.setDatas(Val);
				};
				if(bols && (Val.subjectVo.numberAccounting || Val.subjectVo.foreignCurrency)){
					_.getForeignBySubjectId(Val);
				}else{
					if(Val.subjectVo.change){
						_.getForeignBySubjectId(Val);
					}
				}
			},
			deep:true,
			immediate:true,
		},
		inputFocus:{
			handler(Val){
				const _=this;
				_.enterInputFocus(Val);
			},
			deep:true,
			immediate:true,
		},
	},
}
</script>

<style lang="less">
	#sltemplate{
		text-align: left;
		font-size: 12px;
		padding:5px;
		height: 100%;
		min-height: 56px;
		position: relative;
		.maskAux{
			position: absolute;
			width: 100%;height: 100%;
			left: 0;right: 0;top:0;z-index: 1;
		}
		.middHandle{
			padding:5px 0 5px 7px;
      display: flex;
      .ml15 {
        margin-left: 15px;
      }
      span {
        min-width: 80px;
        display: inline-block;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
			// span{
			// 	display: inline-block;
			// 	max-width: 85px;
      //   text-overflow: ellipsis;
      //   overflow: hidden;
      //   white-space: nowrap;

      //   &:last-child{
      //     width: 70px;
      //   }
			// }
		}
		.el-form-item{
			margin-bottom: 0;
			margin-right: 2px;
			.el-form-item__label{
				height: 25px;line-height: 25px;
			}
			.el-form-item__content{
				height:25px;line-height: 25px;
			}
		}
		.el-input--mini{
			.el-input__inner{
				padding-left: 5px;
				padding-right: 5px;
				height: 25px;line-height: 25px;
			}
		}
		.el-select{
			padding-left: 5px;
			.el-input__inner{
				padding:0 5px;
			}
		}
		.el-input.mini{
			.el-input__inner{
				padding:0 5px;
				height: 25px;
			}
		}
		.el-form-item__label{
			font-size: 12px;
			padding:0 6px 0 0
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/table/slTemplate.vue